import React from 'react';
import { Target, BadgeCheck, Handshake, Compass } from 'lucide-react';
import { WHY_CHOOSE_US } from '../mock';

const iconMap = { Target, BadgeCheck, Handshake, Compass };

const WhyChooseUs = () => {
  return (
    <section id="why" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-[12px] font-medium text-slate-700 uppercase tracking-[0.18em]">
              Why teams pick Scatura
            </div>
            <h2 className="mt-4 font-display text-[36px] md:text-[52px] leading-[1.05] font-semibold tracking-tight text-slate-900">
              We don’t advise.{' '}
              <span className="text-indigo-600">We deliver.</span>
            </h2>
            <p className="mt-5 text-[16.5px] leading-relaxed text-slate-600">
              A boutique studio, staffed only by senior engineers who’ve built and run large-scale systems in the wild. No pyramids. No hand-offs. Just people who ship.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {WHY_CHOOSE_US.map((r) => {
              const Icon = iconMap[r.icon] || Target;
              return (
                <div
                  key={r.title}
                  className="group relative rounded-2xl border border-slate-200 bg-white p-6 hover:-translate-y-0.5 hover:border-indigo-200 hover:shadow-xl hover:shadow-indigo-500/5 transition-all duration-300"
                >
                  <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-indigo-500 to-violet-500 flex items-center justify-center shadow-lg shadow-indigo-500/25">
                    <Icon size={20} className="text-white" strokeWidth={2} />
                  </div>
                  <h3 className="mt-4 font-display text-[19px] font-semibold text-slate-900 tracking-tight">
                    {r.title}
                  </h3>
                  <p className="mt-2 text-[14px] leading-relaxed text-slate-600">
                    {r.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
